module.exports = __webpack_public_path__ + "static/p1-ab1af941199c00db0399e420e10db129.jpg";